import { z } from 'zod';

import { optionalString, requiredString } from '@utils/validation';
import { commonErrors } from '@utils/error';

export const testContent = {};

export const schema = z.object({
	companyName: optionalString,
	idImage: optionalString,
	legalFirstName: requiredString(commonErrors.responseRequired),
	legalLastName: requiredString(commonErrors.responseRequired),
});
